import { actionTypes } from './action';
import { actionTypes as userActionTypes } from '../user/action';

export const defaultQuestState = [];

export const QuestReducer = (state = defaultQuestState, action) => {
    switch (action.type) {
        case actionTypes.SET_QUESTS:
            return Array.isArray(action.payload) ? action.payload : defaultQuestState;
        case actionTypes.CLEAR_QUESTS:
        // The stored list is shown at once when the Quests tab opens, so it must
        // never outlive the account it was loaded for.
        case userActionTypes.SET_USER_TOKEN:
        case userActionTypes.REMOVE_USER_TOKEN:
            return defaultQuestState;
        default:
            return state;
    }
};
